import Set from './set.entity';
import { stringCompare } from '@synconset/sorting';

export function compare(a: Set, b: Set): number {
	if (a.number && !b.number) {
		return -1;
	} else if (!a.number && b.number) {
		return 1;
	} else {
		const diff = Number(a.number) - Number(b.number);
		if (diff !== 0) {
			return diff;
		}
	}

	return stringCompare(a.name, b.name);
}

export function sort(sets: Set[]) {
	return sets.sort(compare);
}
